import React from 'react'
import DeptContainer from '../../containers/deptmng/DeptContainer'

const DeptViewPage = () => {
  return <DeptContainer/>
}

export default DeptViewPage